module.exports = __webpack_public_path__ + "static/media/report.91d30835.svg";